/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
  CmpStatusIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { StockTransferReceipt_summary_GETROW } from "../../Server/ApiV2";
import { useSelector } from "react-redux";
import {
  Set_SliceStockTransferReceipt_SummaryObj,
  Set_SliceStockTransferReceipt_HeadObj,
} from "./SliceStockTransferReceipt";
import { GetAttributes } from "./StockTransferReceiptAction";

import { GetGitterColumns } from "../../Utility/Utilitys";
import moment from "moment";
import StockTransferReceipt_BreadCrumbs from "./StockTransferReceipt_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { StockTransferReceiptSummaryTblCard } from "./processComponent/StockTransferReceiptSummaryTblCard";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";

export default function StockTransferReceipt() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [Summary_Grid_Columns, setSummary_Grid_Columns] = useState([
    {
      field: "A_VocTyp",
      headerName: "Doc.Type",
      width: 150,
    },
    {
      field: "VocName",
      headerName: "VocName",
      width: 200,
    },
    {
      field: "A_VocNo",
      headerName: "Voc.No",
      width: 100,
    },

    {
      field: "A_VocDt",
      headerName: "Date",
      width: 300,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "A_Loc",
      headerName: "From.Loc",
      width: 100,
    },
    {
      field: "FromLocation",
      headerName: "From Location",
      width: 100,
    },
    {
      field: "A_LocTo",
      headerName: "To Location",
      width: 100,
    },
    {
      field: "ToLocation",
      headerName: "To Location",
      width: 100,
    },
    {
      field: "A_DocStat",
      headerName: "Doc.Status",
      width: 200,
    },
  ]);
  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  const [sStatus, setStatus] = useState([
    {
      id: "Pending",
      statusName: "Pending",
    },
    {
      id: "Completed",
      statusName: "Completed",
    },
    {
      id: "All",
      statusName: "All",
    },
    {
      id: "Progress",
      statusName: "Progress",
    },
  ]);
  const [sLocFrom, setLocFrom] = useState([]);
  const [sLocTo, setLocTo] = useState([]);
  const [sSummaryObj, setSummaryObj] = useState({
    loc: "",
    locTo: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    status: "",
  });
  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  const fLoad = (e) => {
    dispatch(
      Set_SliceStockTransferReceipt_SummaryObj({
        sSummaryObj,
      })
    );
    Get_Load_Grid_Data(
      sSummaryObj.loc,
      sSummaryObj.locTo,
      sSummaryObj.dateFrom,
      sSummaryObj.dateTo,
      sSummaryObj.status,
      vRdxuserInfo.UserID
    );
  };
  const Get_Load_Grid_Data = useCallback(
    async (xLoc, xLocTo, xDate1, xDate2, xStatus, xUserCd) => {
      var vSummaryObj = {
        v_From_Loc: xLoc,
        v_To_Loc: xLocTo,
        v_Date1: moment(xDate1).format("MM/DD/YYYY"),
        v_Date2: moment(xDate2).format("MM/DD/YYYY"),
        v_DocStat: xStatus,
        v_UserCd: xUserCd,
      };
      // var vSummaryObj = {
      //   v_Date1: "01/01/2023",
      //   v_Date2: "01/01/2099",
      //   v_From_Loc: "All",
      //   v_To_Loc: "All",
      //   v_DocStat: "All",
      //   v_UserCd: "001",
      // };
      const vItemSearch = await StockTransferReceipt_summary_GETROW(
        vSummaryObj
      );

      if (vItemSearch?.status === 200) {
        if (vItemSearch?.data?.ResultSet?.length > 0) {
          const itemRows = vItemSearch?.data?.ResultSet?.map((obj, i) => ({
            ...obj,
            id: i + 1,
            // A_Date: moment(obj.A_Date).format("DD/MM/YYYY"),
          }));
          setSummaryGridRow(itemRows);
          setShowModal(false);
        } else {
          setSummaryGridRow([]);
          setShowModal(false);
        }
      }
    },
    []
  );

  const fRowClick = (item) => {
    dispatch(
      Set_SliceStockTransferReceipt_HeadObj({
        DocType: item?.A_VocTyp,
        DocTypeName: item?.VocName,
        DocNo: item?.A_VocNo,
        Date: item?.A_VocDt,
        Loc: item?.A_Loc,
        LocName: item?.FromLocation,
        LocTo: item?.A_LocTo,
        LocNameTo: item?.ToLocation,
        A_DocStat: item?.A_DocStat,
      })
    );
    navigate("/StockTransferReceiptDetail");
  };
  const fNew = () => {
    dispatch(
      Set_SliceStockTransferReceipt_SummaryObj({
        loc: "",
        locTo: "",
        dateFrom: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 10
        ),
        dateTo: new Date(),
        status: sStatus[0]?.UId,
      })
    );
    setSummaryObj((obj) => ({
      ...obj,
      loc: sLocFrom[0]?.UId,
      locTo: sLocTo[0]?.UId,
      dateFrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() - 10
      ),
      dateTo: new Date(),
      status: sStatus[0]?.UId,
    }));
    // navigate("/StockTransferReceiptDetail");
  };

  const fOnLoad = useCallback(async () => {
    let iAttributeResp = await GetAttributes(setStatus, setLocTo, setLocFrom);

    if (Object.keys(iAttributeResp).length !== 0) {
      setSummaryObj((obj) => ({
        ...obj,
        loc: iAttributeResp.FromLoc[0]?.UId,
        locTo: iAttributeResp.ToLoc[0]?.UId,
        status: iAttributeResp.Status[0]?.UId,
      }));
      Get_Load_Grid_Data(
        iAttributeResp.FromLoc[0]?.UId,
        iAttributeResp.ToLoc[0]?.UId,
        sSummaryObj.dateFrom,
        sSummaryObj.dateTo,
        iAttributeResp.Status[0]?.UId,
        vRdxuserInfo.UserID
      );
    }
  }, []);
  useEffect(() => {
    fOnLoad();
  }, [fOnLoad]);

  // useEffect(() => {
  //   Get_Load_Grid_Data(
  //     sSummaryObj.loc,
  //     sSummaryObj.locTo,
  //     sSummaryObj.dateFrom,
  //     sSummaryObj.dateTo,
  //     sSummaryObj.status,
  //     vRdxuserInfo.UserID
  //   );
  // }, [
  //   sSummaryObj.loc,
  //   sSummaryObj.locTo,
  //   sSummaryObj.dateFrom,
  //   sSummaryObj.dateTo,
  //   sSummaryObj.status,
  //   vRdxuserInfo.UserID,
  //   Get_Load_Grid_Data,
  // ]);

  useEffect(() => {
    LocationFocusOnLoad?.current?.focus();
  }, []);

  useEffect(() => {
    GetGitterColumns(
      setSummary_Grid_Columns,
      "INV10RSUMGETWB",
      Summary_Grid_Columns
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center px-2">
        <StockTransferReceipt_BreadCrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      <div style={{ margin: "auto", width: "100%" }}>
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center"
          style={{ display: "none" }}
        >
          <Grid item lg={1.3} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={sSummaryObj.dateFrom}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  dateFrom: newValue.$d,
                }));
              }}
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={1.3} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={sSummaryObj.dateTo}
              xOnChange={(newValue) =>
                setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={3} md={4} xs={6}>
            <CmpSelectBox
              xref={LocationFocusOnLoad}
              xLabelText="Location"
              xValue={sSummaryObj.loc}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"loc"}
              xData={sLocFrom}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={3} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="To Location"
              xValue={sSummaryObj.locTo}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"locTo"}
              xData={sLocTo}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>

          <Grid item lg={3} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="Status"
              xValue={sSummaryObj?.status}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"status"}
              xData={sStatus}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 0 }}
          className="align-items-center justify-content-end pt-2"
          style={{ display: "none" }}
        >
          <Grid item lg={1} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>

          <Grid item lg={1} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid>
        <>
          {/* <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sSummaryGridRow}
              columns={Summary_Grid_Columns}
              hideFooter={sSummaryGridRow.length < 100}
              onRowClick={fRowClick}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            /> */}

          {/* <StockTransferReceiptSummaryTblCard data={sSummaryGridRow} onClick={fRowClick} /> */}

          <Box
            sx={{
              height: vMediaQuery ? "65vh" : "72vh",
              overflowY: "auto",
              py: vMediaQuery ? "0px" : "8px",
              px: vMediaQuery ? "0px" : "20px",
            }}
          >
            <Grid container spacing={2}>
              {Array.isArray(sSummaryGridRow) &&
                sSummaryGridRow?.length > 0 &&
                sSummaryGridRow?.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <DetailCardComp
                      data={item}
                      onClick={(item) => {
                        fRowClick(item);
                      }}
                      headerLabel={item?.VocName}
                      content={
                        <Grid container spacing={1}>
                          <DetailInputDisplay
                            label=" VocNo"
                            value={item?.A_VocNo}
                          />
                          <DetailInputDisplay
                            label="Date"
                            value={moment(item?.A_VocDt).format("DD/MM/YYYY")}
                          />
                          <DetailInputDisplay
                            label="FromLocation"
                            value={` ${item?.FromLocation}`}
                          />
                          <DetailInputDisplay
                            label="ToLocation"
                            value={item?.ToLocation}
                          />

                          <DetailInputDisplay
                            label="Status"
                            value={<CmpStatusIcon xStatus={item?.A_DocStat} />}
                          />
                        </Grid>
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </Box>
        </>
      </div>
      <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        component={
          <>
            <Grid container spacing={2} className="align-items-center">
              <Grid item xs={6}>
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={sSummaryObj.dateFrom}
                  xOnChange={(newValue) => {
                    setSummaryObj((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }));
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={sSummaryObj.dateTo}
                  xOnChange={(newValue) =>
                    setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  xLabelText="Location"
                  xValue={sSummaryObj.loc}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"loc"}
                  xData={sLocFrom}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpSelectBox
                  xLabelText="To Location"
                  xValue={sSummaryObj.locTo}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"locTo"}
                  xData={sLocTo}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpSelectBox
                  xLabelText="Status"
                  xValue={sSummaryObj?.status}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"status"}
                  xData={sStatus}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>

              <Grid
                container
                spacing={{ xs: 2, sm: 2, md: 0 }}
                className="align-items-center pt-2"
              >
                <Grid
                  item
                  xs={6}
                  className="bintransfet-data-load-btn text-center"
                >
                  <CmpButton
                    xbtnName="Load"
                    xOnClick={fLoad}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>

                <Grid
                  item
                  xs={6}
                  className="bintransfet-data-load-btn text-center"
                >
                  <CmpButton
                    xbtnName="New"
                    xOnClick={fNew}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        }
      />
    </div>
  );
}
